import './Menu.css'

import { useState, useEffect } from 'react'

export default function Menu(props)
{

    const [menuOpen, setMenuOpen] = useState(false)
    return (
        <header >
            <div className={props.visible ? 'background-text-wrapper in' : 'background-text-wrapper'}>
                <h2 className='background-text-header'>The Death of the Cyrus Cylinder</h2>
                {/* <h3 className='background-text-subhead'>Witness its meaning getting destroyed every time human rights violations in Iran hit the news.</h3> */}
            </div>

            <div className={`menu-animate-wrapper ${menuOpen && 'open'}`}>
                <nav className='menu-wrapper'>
                    <ul className='menu-list-wrapper'>
                        <li className='menu-item'><a href="/">home</a></li>
                        <li className='menu-item'><a href="/context">context</a></li>
                        <li className='menu-item'><a href="/faq">what's happening</a></li>
                        <li className='menu-item'><a href="/how-can-I-help">how can I help</a></li>
                    </ul>
                    <img alt="" title="Center for Human Rights in Iran" className="menu-logo-image" src={require('../images/CHRI-Logo.webp')} />
                </nav>
            </div>
            <button onClick={() => { setMenuOpen(prevValue => !prevValue) }} className={`menu-button ${menuOpen && 'open'} ${props.visible && 'visible'}`}>menu</button>
        </header>
    )
}